// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1o4DK","list":"BalanceDue_list__2XemY","listRow":"BalanceDue_listRow__2EHXC","total":"BalanceDue_total__mwCeh"};